
class DataCacheService {
    constructor (_opts) {
        this.cache = new Map();
    }

    stash (gid, data) {
        this.cache.set(gid, data);
    }

    getGame (gid) {
        this.cache.get(gid);
    }
}
export default DataCacheService;